const signerRequests = new Map();

export const getSwapSigner = async (chain) => {
  if (!["base", "arbitrum", "polygon", "bsc", "solana"].includes(chain)) return null;
  if (!signerRequests.has(chain)) {
    const base = String(import.meta.env.VITE_API_BASE_URL || "http://localhost:8000").replace(/\/$/, "");
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 5000);
    const request = fetch(`${base}/users/swap/signer?chain=${encodeURIComponent(chain)}`, { signal: controller.signal })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        const locator = String(data?.locator || "");
        const valid = chain === "solana"
          ? /^server:[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(locator)
          : /^server:0x[a-fA-F0-9]{40}$/.test(locator);
        return valid && data.chain === chain ? data : null;
      })
      .catch(() => null)
      .then((result) => {
        if (!result) signerRequests.delete(chain);
        return result;
      }).finally(() => window.clearTimeout(timer));
    signerRequests.set(chain, request);
  }
  return signerRequests.get(chain);
};
